module.exports = __webpack_public_path__ + "static/img/newHuoke.359a34dc.png";